function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { WhiteboardTool } from './WhiteboardTool';
export class GrabTool extends WhiteboardTool {
  constructor(enableToolEvent, modelGetter, shadowEmitter, scope, camera) {
    super(enableToolEvent, modelGetter, shadowEmitter, scope);
    _defineProperty(this, "camera", void 0);
    _defineProperty(this, "downPoint", null);
    _defineProperty(this, "showLiveCursor", false);
    this.camera = camera;
  }
  onMouseDown(event) {
    this.downPoint = event.point;
    this.shadowEmitter.emit('grabDown');
  }
  onMouseDrag(event) {
    if (this.downPoint) {
      this.camera.translate(event.point.x - this.downPoint.x, event.point.y - this.downPoint.y);
    } else {
      this.downPoint = event.point;
    }
  }
  onMouseUp() {
    this.downPoint = null;
    this.shadowEmitter.emit('grabUp');
  }
}